<template>
  <div :class="activateCompetency ? 'active' : 'inactive'">
    <h1 class="mb-base text-left">{{ $t('alex.myLibrary') }}</h1>
    <div class="flex -mx-3 relative">
      <div class="px-3 lg:w-1/3 sm:w-1/2 w-full">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div :class="activateCompetency ? 'active-image-wrapper' : 'image-wrapper'">
              <img
                :src="libraryItemList[0].imageUrl"
                width="100%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[0].title }}</h5>
            <p class="text-sm">{{ libraryItemList[0].description }}</p>
          </div>
          <template slot="footer">
            <div class="flex justify-end items-center">
              <p class="card-footer-text mr-1">{{ $t('alex.startLibraryCourse') }}</p>
              <arrow-right-icon
                size="1x"
                class="footer-icon"
              ></arrow-right-icon>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="px-3 lg:w-1/3 sm:w-1/2 sm:block hidden">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div :class="activateCompetency ? 'active-image-wrapper' : 'image-wrapper'">
              <img
                :src="libraryItemList[1].imageUrl"
                width="100%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[1].title }}</h5>
            <p class="text-sm">{{ libraryItemList[1].description }}</p>
          </div>
          <template slot="footer">
            <div class="flex justify-end items-center">
              <p class="card-footer-text mr-1">{{ $t('alex.startLibraryCourse') }}</p>
              <arrow-right-icon
                size="1x"
                class="footer-icon"
              ></arrow-right-icon>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="px-3 lg:w-1/3 lg:block hidden">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div :class="activateCompetency ? 'active-image-wrapper' : 'image-wrapper'">
              <img
                :src="libraryItemList[2].imageUrl"
                width="100%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[2].title }}</h5>
            <p class="text-sm">{{ libraryItemList[2].description }}</p>
          </div>
          <template slot="footer">
            <div class="flex justify-end items-center">
              <p class="card-footer-text mr-1">{{ $t('alex.startLibraryCourse') }}</p>
              <arrow-right-icon
                size="1x"
                class="footer-icon"
              ></arrow-right-icon>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="view-more" v-if="activateCompetency" >
        <a href="/dpd-belux/alex/library"> <img src="../../../../../assets/images/icons/alex/arrow_right_orange.svg" /></a>
      </div>
      <div class="view-more" v-else >
        <img src="../../../../../assets/images/icons/alex/arrow_right_grey.svg" />
      </div>
    </div>
  </div>
</template>
<script>
import { ArrowRightIcon } from "vue-feather-icons";

export default {
  components: {
    ArrowRightIcon,
  },
  data() {
    return {
      libraryItemList: [
        {
          itemId: "",
          imageUrl:
            "https://assets-global.website-files.com/5a690960b80baa0001e05b0f/5dea952e434dea34b38ea9c5_podcast-episode-24%402x-p-500.jpeg",
          title: "Avoiding Burnout with Lynn Winter",
          description:
            "Proactive workers are in high demand, and it’s easy to understand why. When it comes to creating positive change, these employees don’t need to be told to take initiative.",
        },
        {
          itemId: "",
          imageUrl:
            "https://i.imgur.com/tjsyNOH_d.webp?maxwidth=760&fidelity=grand",
          title:
            "10 Steps to Launching a Successful Process Improvement Initiative",
          description:
            "To move people analytics forward, people experts need the skills to ask the right questions of the data and turn",
        },
        {
          itemId: "",
          imageUrl:
            "https://my.goodhabitz.com/ghcc_media/0128_vierkant_EN-ts1xw.png",
          title: "Asking for Feedback",
          description:
            "Conquer anxiety, reduce stress, increase productivity and improve relationships. All by being attentive and cherishing the moment. This is mindfulness.",
        },
      ],
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    autoLoginToken() {
      return "?tk=MhCI9rtezBuDDW88";
    },
    userProgress() {
      return 2;
    },
    activateFeedback() {
      return  1;
    },
    activateCompetency() {
      return  2;
    },
    activatePreferences() {
      return  2;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    }
  },
};
</script>
<style scoped>
p {
  line-height: unset;
  font-size: unset;
}
section {
  padding: 8rem 0;
}
.active h1,
.active h5 {
  color: #231d4f;
}
.active p {
  color: #848199;
}
.active p.card-footer-text,
.active .footer-icon {
  color: #dc0032;
}
.inactive h1,
.inactive p,
.inactive h5,
.inactive .footer-icon {
  color: #ccc !important;
}
.inactive div.vx-card {
  border: 1px solid #eaf1fb;
}
.training-item-body {
  min-height: 140px;
}
.image-wrapper img {
  position: absolute;
}
.image-wrapper {
  position: relative;
  height: 300px;
  width: 100%;
  overflow: hidden;
  opacity: 0.2;
}
.active-image-wrapper{
  position: relative;
  height: 300px;
  width: 100%;
  overflow: hidden;
  opacity: 1;
}
.view-more {
  position: absolute;
  right: -25px;
  top: 275px;
}
</style>
